<script setup>
import HeaderContainer from '@/components/header/HeaderContainer.vue';
import SidebarContainer from '@/components/sidebar/SidebarContainer.vue';
import ChangelogPopup from '@/components/ChangelogPopup.vue';
import GuideTour from '@/components/GuideTour/GuideTour.vue';
import GrooveWidget from '@/components/GrooveWidget.vue';
</script>

<template>
    <div class="bg-overlay"></div>

    <div class="app-container">
        <SidebarContainer />

        <div class="content-container">
            <HeaderContainer />
            
            <main class="main-content">
                <slot />
            </main>
        </div>
    </div>

    <!-- Global Toast Notifications are rendered persistently from app.js -->

    <!-- Changelog Popup -->
    <ChangelogPopup />

    <!-- Guide Tour (auto-starts on dashboard for new users) -->
    <GuideTour />

    <GrooveWidget />
</template>
<style scoped>
/* Using consolidated layout styles from our new CSS architecture */
/* Component-specific overrides only */
</style>
